import { render } from "./MFITTSeatVacant.vue?vue&type=template&id=a13831c8&scoped=true"
import script from "./MFITTSeatVacant.vue?vue&type=script&lang=js"
export * from "./MFITTSeatVacant.vue?vue&type=script&lang=js"

import "./MFITTSeatVacant.vue?vue&type=style&index=0&id=a13831c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a13831c8"

export default script